import React from "react";
import { ArrowRightCircle, CheckCircle2 } from "lucide-react";
import ClipLoader from "react-spinners/ClipLoader";

import { Meeting, SessionAnalysis } from "../../../../../types/supabase";

interface MeetingSummaryProps {
  meeting: Meeting;
  analysis: SessionAnalysis;
}

export const MeetingSummary: React.FC<MeetingSummaryProps> = ({
  meeting,
  analysis,
}) => {
  return (
    <div className="bg-white rounded-xl p-6 shadow-sm">
      <h2 className="text-2xl font-semibold mb-4">
        Great job mentoring, {meeting.mentor?.vincer_base_user.name}! Here are
        key takeaways with your session with{" "}
        {meeting.mentee?.vincer_base_user.name}:
      </h2>

      <div className="text-green-600 mb-4">
        Session on{" "}
        {new Date(meeting.scheduled_time).toLocaleDateString("en-US", {
          day: "numeric",
          month: "long",
        })}
      </div>

      <div className="flex items-start gap-4 mb-6">
        <div>
          <div className="text-gray-800">
            {analysis?.content?.summary ? (
              <p className="text-gray-600 mb-2">{analysis?.content?.summary}</p>
            ) : (
              <div className="flex flex-col items-center justify-center h-full">
                <ClipLoader color="#000" size={10} />
                <p className="text-gray-600 mb-6">Loading...</p>
              </div>
            )}
          </div>
          <div className="text-green-600">
            {meeting.duration}-minute call with{" "}
            {meeting.mentee?.vincer_base_user.name}
          </div>
        </div>
      </div>

      <div className="space-y-2">
        <h3 className="text-xl font-semibold text-gray-900">Key Insights</h3>
        <div className="flex flex-col space-y-2">
          {analysis?.content?.key_topics &&
            analysis?.content?.key_topics.map((theme) => (
              <span key={theme} className="flex items-center gap-2 text-sm">
                <CheckCircle2 className="w-8 h-8 text-green-500" />
                <span className="px-3 py-1 rounded-full text-lg">
                  {theme.charAt(0).toUpperCase() + theme.slice(1)}
                </span>
              </span>
            ))}
        </div>
      </div>
      <div className="bg-white rounded-lg mt-5">
        <h2 className="text-xl font-semibold mb-4">Next Steps</h2>
        <div className="space-y-3">
          {analysis?.content?.next_steps?.map((step, index) => (
            <div key={index} className="flex items-start">
              <ArrowRightCircle className="flex-shrink-0 w-6 h-6 text-blue-400 mr-3" />
              <p className="text-gray-700">{step}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
